
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "DashboardToggleSwitch2904327176",
      {"classes":{"root":"DashboardToggleSwitch2904327176__root","toggleSwitchWrapper":"DashboardToggleSwitch2904327176__toggleSwitchWrapper"},"vars":{},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  